import { dateTimeOrNotSet } from './date-time-or-not-set.js';
import { orNotSet } from './or-not-set.js';
// "Approved by ..." applies from Submitted onward (spec A-1b); a rejected order never was approved.
const APPROVED_LINE_STATUSES = new Set([
    'SUBMITTED',
    'ACCEPTED',
    'DELIVERY_SCHEDULING',
    'READY_TO_DELIVER',
    'SHIPPED',
    'DELIVERED',
    'COMPLETE',
]);
// AP-3: the decision's outcome isn't stored, and an order cancelled from Awaiting Approval may have been rejected.
const DECIDED_LINE_STATUSES = new Set([
    'AWAITING_APPROVAL',
    'CANCELLED',
]);
function decisionVerb(status) {
    if (DECIDED_LINE_STATUSES.has(status))
        return 'Decided';
    return APPROVED_LINE_STATUSES.has(status) ? 'Approved' : undefined;
}
/** "Approved by …" (or "Decided by …") under the Next Step message, from Submitted on (A-1b). */
export function salesOrderApprovedLine(input) {
    const { approval } = input;
    if (!approval)
        return undefined;
    const verb = decisionVerb(input.status);
    if (!verb)
        return undefined;
    const reason = approval.reason?.trim();
    const base = `${verb} by ${orNotSet(approval.by)} · ${dateTimeOrNotSet(approval.at)}`;
    return reason ? `${base} · Reason: ${reason}` : base;
}
//# sourceMappingURL=sales-order-next-step-approved-line.js.map